import store from "@/store";
import axios from "axios";
import { agencyCode } from "@/repositories/api";

// Il baseURL arriva dal backend al login (integrations.lisacomunica.base_url)
// e si imposta a ogni richiesta, quando lo store è già popolato.
const LC = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// LisaComunica accetta il token Sanctum di LisaWeb e il codice agenzia
// nell'header "Agenzia" (nome fisso lato LisaComunica, CORS compreso).
// Il token si legge a ogni richiesta: dopo un nuovo login o un cambio di
// agenzia quello vecchio non e' piu' valido. Senza token non si manda l'header.
// Senza URL configurato la richiesta finirebbe sull'host della SPA: errore.
LC.interceptors.request.use((config) => {
  config.baseURL = store.getters["auth/lisacomunicaBaseUrl"];
  if (!config.baseURL) {
    return Promise.reject(new Error("LisaComunica non configurata"));
  }
  const token = store.state.auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers.Agenzia = agencyCode();
  return config;
});

export default LC;
